/**
 * Human-readable API error message from Axios / Django REST payloads.
 *
 * @param {unknown} error
 * @returns {string}
 */
export function getApiErrorMessage(error) {
  const res = error?.response;
  const data = res?.data;
  if (typeof data?.detail === "string") {
    return data.detail;
  }
  if (Array.isArray(data?.detail)) {
    return data.detail.map((e) => (typeof e === "string" ? e : JSON.stringify(e))).join(" ");
  }
  if (data && typeof data === "object") {
    const entries = Object.entries(data);
    if (entries.length) {
      const [field, val] = entries[0];
      const msg = Array.isArray(val) ? val[0] : val;
      return typeof msg === "string" ? `${field}: ${msg}` : `${field}: ${JSON.stringify(msg)}`;
    }
  }
  if (typeof error?.message === "string" && error.message) {
    return error.message;
  }
  return "Something went wrong. Try again.";
}
